'use client';

import { c as _c } from "react/compiler-runtime";
import './chip.scss';
import { useTranslation } from 'react-i18next';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { IconNames } from '@sola/schema/lib/icons/icon-names.ts';
import { cn } from '../../utils/helpers.ts';
export type Chip = {
  name: string;
  value: string;
  icon?: IconNames;
  isClear?: boolean;
  isSelected?: boolean;
  onClick?: () => void;
  className?: string;
  onRemove?: () => void;
  removable?: boolean;
  size?: 'sm' | 'md';
};
const sizeClasses: Record<'sm' | 'md', string> = {
  sm: 'gap-snug-md px-snug-xl py-snug-md',
  md: 'gap-snug-md px-comfy-xs py-snug-xl'
};
export const Chip: React.FC<Chip> = t0 => {
  const $ = _c(20);
  const {
    name,
    value,
    icon,
    isSelected,
    onClick,
    className,
    onRemove,
    removable,
    size: t1
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["gift-catalog"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation(t2);
  const t3 = `Chip flex items-center justify-center label label-moderate ${sizeClasses[size]}`;
  let t4;
  if ($[1] !== className || $[2] !== isSelected || $[3] !== t3) {
    t4 = cn(t3, className, {
      "Chip--active": isSelected
    });
    $[1] = className;
    $[2] = isSelected;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== icon) {
    t5 = icon && <ArkIcon iconName={icon} />;
    $[5] = icon;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== name || $[8] !== onRemove || $[9] !== removable || $[10] !== t) {
    t6 = removable && <span role="button" tabIndex={0} className="Chip__close ml-snug-xs flex items-center justify-center p-none" onClick={e => {
      e.stopPropagation();
      onRemove?.();
    }} onKeyDown={e_0 => {
      if (e_0.key === "Enter" || e_0.key === " ") {
        e_0.preventDefault();
        e_0.stopPropagation();
        onRemove?.();
      }
    }} aria-label={t("gift-catalog:remove", {
      name
    })}><ArkIcon iconName="x-close" /></span>;
    $[7] = name;
    $[8] = onRemove;
    $[9] = removable;
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isSelected || $[13] !== name || $[14] !== onClick || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== value) {
    t7 = <button type="button" aria-pressed={isSelected} onClick={onClick} key={value} className={t4}>{t5}{name}{t6}</button>;
    $[12] = isSelected;
    $[13] = name;
    $[14] = onClick;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = value;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};